import { HttpClient } from '../../httpClient'
import { validateHttpResponse } from '../../httpClient/utils'

export const deleteUserFromOrganization = async (client: HttpClient, organizationId: string, userId: string): Promise<void> => {
	const response = await client.delete(`/api/organizations/${organizationId}/users/${userId}`, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
	})

	await validateHttpResponse(response)
}
